import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a12ce5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "global-search-menu-filter" }

import { getComponentUiText } from "@/utils/utilities";

/** components */
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import { TopicName } from "@/components/common/globalSearch/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'menuFilter',
  props: {
    selectedFilterIds: {}
  },
  emits: ["on-select"],
  setup(__props: any, { emit }) {

const props = __props;





const arrayFilters = [
  {
    id: TopicName.all,
    title: "app-header-menu-search-option-filter-all-1",
  },
  {
    id: TopicName.page,
    title: "app-header-menu-search-option-filter-page-1",
  },
  {
    id: TopicName.org,
    title: "app-header-menu-search-option-filter-org-1",
  },
  {
    id: TopicName.assessment,
    title: "app-header-menu-search-option-filter-assessment-1",
  },
  {
    id: TopicName.recommend,
    title: "app-header-menu-search-option-filter-recommendations-1",
  },
  {
    id: TopicName.help,
    title: "app-header-menu-search-option-filter-help-topics-1",
  },
  {
    id: TopicName.setting,
    title: "app-header-menu-search-option-filter-settings-1",
  },
];

const onSelect = (isChecked: boolean, id: string) => {
  if (id === TopicName.all) {
    return emit("on-select", [isChecked ? TopicName.all : TopicName.page]);
  }
  const ids = props.selectedFilterIds.filter(
    (item) => item !== TopicName.all && item !== id,
  );
  if (isChecked) {
    ids.push(id);
  }
  return emit("on-select", !ids.length ? [TopicName.all] : ids);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-header-menu-search-text-filter-1")), 1),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(arrayFilters, (item) => {
      return _createVNode(CustomCheckBox, {
        key: item.id,
        title: _unref(getComponentUiText)(item.title),
        class: "global-search-menu-right-checkbox-item",
        "is-checked": _ctx.selectedFilterIds.includes(item.id),
        size: '20px',
        disabled: 
        item.id === _unref(TopicName).all && _ctx.selectedFilterIds.includes(item.id)
      ,
        "color-checkmark": "#01893D",
        "onUpdate:isChecked": ($event: any) => (onSelect($event, item.id))
      }, null, 8, ["title", "is-checked", "disabled", "onUpdate:isChecked"])
    }), 64))
  ]))
}
}

})